
<div class="d-flex">
    <div ngbDropdown class="input-group-prepend gap" #matchDropDown="ngbDropdown" *ngIf="(enableTagMatch === true && siteTypeCode) || enableMultiSelect === true">
        <button class="btn btn-outline-secondary" ngbDropdownToggle>
            <i *ngIf="!showTagMatch" class="fa fa-tag"></i>
            <i *ngIf="showTagMatch" class="fa fa-tags"></i>
        </button>
        <div ngbDropdownMenu>
            <button ngbDropdownItem (click)="toggleTagMatch(false);"><i class="fa fa-tag"></i> Single</button>
            <button ngbDropdownItem [disabled]="!(enableTagMatch === true)" (click)="toggleTagMatch(true);"><i class="fa fa-tags"></i> Meta Match</button>
        </div>
    </div>

    <div ngbDropdown class="input-group-append gap" #typeDropDown="ngbDropdown" *ngIf="enableTimeSeriesSearch && enableMediaSearch">
        <button class="btn btn-outline-secondary" ngbDropdownToggle>
            <i *ngIf="inputType == 'TimeSeries'" class="fa fa-line-chart"></i>
            <i *ngIf="inputType == 'Media'" class="fa fa-camera"></i>
        </button>
        <div ngbDropdownMenu>
            <button ngbDropdownItem [disabled]="!enableTimeSeriesSearch" (click)="inputType = 'TimeSeries'"><i class="fa fa-line-chart"></i> Time Series</button>
            <button ngbDropdownItem [disabled]="!enableMediaSearch"  (click)="inputType = 'Media'"><i class="fa fa-camera"></i> Media</button>
        </div>
    </div>
    
    <div ngbDropdown class="input-group flex-grow-1" #searchDropdown="ngbDropdown" *ngIf="!showTagMatch">
        <input type="text" placeholder="{{timeSeriesDetail == null ? 'Search...' : timeSeriesDetail.uri}}" class="form-control" [(ngModel)]="filter" 
            (click)="$event.stopPropagation()" (keyup.enter)="doSearch();searchDropdown.open()">
        <button type="button" ngbDropdownToggle class="btn btn-outline-default" 
            (click)="doSearch()" ><i class="bi bi-search"></i> </button>
        <button type="button" class="btn btn-outline-default" 
            (click)="saveSearchAsUri()" title="Force save searchs string as URI"><i class="fa fa-save"></i> </button>
        <div ngbDropdownMenu aria-labelledby="searchDropdown" container="body" class="dropdown-menu dropdown-menu-end">
            <span *ngIf="searching">
                <div class="dropdown-item">
                    <div class="spinner-border text-success"></div>
                </div>
            </span>
            <span class="mr-2" *ngFor="let result of searchResults">
                <div class="dropdown-item">
                    <h3 class="h6">{{result.siteName}}</h3>
                </div>
                <button ngbDropdownItem *ngFor="let item of result.items" [ngClass]="{'selected':item.uri == timeSeriesDetail.uri}" (click)="select(item, result);searchDropdown.close()">
                    <i *ngIf="item.type == 'TimeSeries'" class="fa fa-line-chart"></i> 
                    <i *ngIf="item.type == 'Media'" class="fa fa-camera"></i> 
                    {{item.name}}
                </button>
                <div class="dropdown-divider"></div>
            </span>
            
        </div>
    </div>

    <div ngbDropdown class="input-group flex-grow-1 gap" #unitTypeDropdown="ngbDropdown" *ngIf="showTagMatch && siteUri == null" [autoclose]="'outside'">
        <button type="button" ngbDropdownToggle class="btn btn-outline-default w-100" (click)="populateTagList(null);metaDropdown?.open()">
            Site Type
            <span *ngIf="siteTypeTagMatch && siteTypeTagMatch.tagValue != null"> = {{siteTypeTagMatch.tagValue}}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="metaDropdown" class="dropdown-menu dropdown-menu-end">
            <button ngbDropdownItem (click)="selectSiteType(null)">-- CLEAR --</button>
            <button ngbDropdownItem *ngFor="let siteType of siteTypes" (click)="selectSiteType(siteType.siteTypeCode)">{{siteType.siteTypeCode}}</button>
        </div>
    </div>

    <div ngbDropdown class="input-group flex-grow-1 gap" #unitTypeDropdown="ngbDropdown" *ngIf="showTagMatch && siteUri != null" [autoclose]="'outside'">
        <button type="button" ngbDropdownToggle class="btn btn-outline-default w-100" (click)="populateTagList(null);metaDropdown?.open()">
            Unit Type
            <span *ngIf="unitTypeTagMatch && unitTypeTagMatch.tagValue != null"> = {{unitTypeTagMatch.tagValue}}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="metaDropdown" class="dropdown-menu dropdown-menu-end">
            <button ngbDropdownItem (click)="selectUnitType(null)">-- CLEAR --</button>
            <button ngbDropdownItem *ngFor="let unitType of unitTypes" (click)="selectUnitType(unitType)">{{unitType}}</button>
        </div>
    </div>

    <div ngbDropdown class="input-group flex-grow-1" #unitTypeDropdown="ngbDropdown" *ngIf="showTagMatch && siteUri != null" [autoclose]="'outside'">
        <button type="button" ngbDropdownToggle class="btn btn-outline-default w-100" (click)="populateTagList(null);metaDropdown.open()" >
            Units 
            <span *ngIf="unitTagMatch && unitTagMatch.tagValue != null"> = {{unitTagMatch.tagValue}}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="metaDropdown" class="dropdown-menu dropdown-menu-end">
            <button ngbDropdownItem (click)="selectUnits(null)">-- CLEAR --</button>
            <button ngbDropdownItem *ngFor="let unit of units" (click)="selectUnits(unit)">{{unit}}</button>
        </div>
    </div>

    <!-- if multi select and tag match enabled - then show drop down list of key/value text boxes -->
    <div ngbDropdown class="input-group flex-grow-1" #multiMetaDropdown="ngbDropdown" *ngIf="showTagMatch && siteUri == null && enableMultiSelect" 
    [autoclose]="'outside'" container="body">
        <button type="button" ngbDropdownToggle class="btn btn-outline-default w-100" (click)="populateTagList(null);metaDropdown.open()" >
            Meta Tags ({{timeSeriesDetail.tagMatches?.length || 0}})
        </button>
        <div ngbDropdownMenu aria-labelledby="multiMetaDropdown" class="dropdown-menu dropdown-menu-end">
            <div *ngFor="let tagMatch of timeSeriesDetail.tagMatches">
                <div class="input-group flex-grow-1 gap" *ngIf="tagMatch.tagName !== 'siteType'">
                    <input type="text" class="form-control" placeholder="Tag Name" [(ngModel)]="tagMatch.tagName"/>
                    <input type="text" class="form-control" placeholder="Tag Value" [(ngModel)]="tagMatch.tagValue" />
                    <button type="button" class="btn btn-outline-danger" (click)="removeTagMatch(tagMatch);"><i class="fa fa-trash"></i></button>
                </div>
            </div>
            <div class="dropdown-divider"></div>
            <div class="input-group flex-grow-1 gap">
                <input type="text" class="form-control" placeholder="Tag Name" [(ngModel)]="newTagMatch.tagName"/>
                <input type="text" class="form-control" placeholder="Tag Value" [(ngModel)]="newTagMatch.tagValue" />
                <button type="button" class="btn btn-outline-success" 
                    [disabled]="newTagMatch.tagName == null || newTagMatch.tagValue == null || newTagMatch.tagName === '' || newTagMatch.tagValue === ''" 
                    (click)="addTagMatch(newTagMatch);"><i class="fa fa-plus"></i></button>
            </div>
        </div>
    </div>
</div>

<div class="d-flex pt-2 animate__fadeInDown" *ngIf="showTagMatch && siteUri == null">
    <div class="input-group flex-grow-1 gap" *ngIf="showTagMatch && siteUri == null && metaTagMatch != null">
        <input type="text" class="form-control" placeholder="Tag Name" [(ngModel)]="metaTagMatch.tagName"  />
        <input type="text" class="form-control" placeholder="Tag Value" [(ngModel)]="metaTagMatch.tagValue"  />
    </div>
    <div class="input-group flex-grow-1 gap" *ngIf="showTagMatch && siteUri == null && metaTagMatch2 != null">
        <input type="text" class="form-control" placeholder="Tag Name" [(ngModel)]="metaTagMatch2.tagName"  />
        <input type="text" class="form-control" placeholder="Tag Value" [(ngModel)]="metaTagMatch2.tagValue"  />
    </div>
</div>